import { LiveReplay } from '~/types';

export default function isReplayReady(replay: LiveReplay): boolean {
  // We aren't live, the replay has ended, and the replay has a source_url
  return !replay.is_live && !!replay.ended_at && !!replay.source_url;
}
